export default __webpack_public_path__ + "images/KO.422ebe1.png";